import { Cliente } from '../../objetos/objeto_cliente';
import { clientesApi } from '../../services/api';
import React, { useMemo, useState } from 'react';
import { useLoading } from '../../utils/LoadingProvider';
import { toast } from 'react-toastify';
import { getSocket } from '../../services/socket';
import { useConfiguracion } from '../../metodos/ConfiguracionContext';

export const useClientesModel = () => {
    const { withLoading } = useLoading();
    const [clientesProUnad, setClientes] = useState([]);
    const [allClientes, setClientesAll] =  useState([]);
    const [clientes,setClientesBusqueda] = useState([]);
    const [cliente,setCliente] = useState();
    //lista de campaña
    const[campanaList, setCampanalist] = useState();

    const [loadingClientes, setLoading] = useState(true);
    const [errorClientes, setError] = useState(null);

    const {configuracion} = useConfiguracion()
    
    //añadir
    const addCliente = (nombreEmpresa,clienteData) =>{
      console.log("añadir cliente");

      return withLoading(async () =>{

        try{
          console.log("añadir cliente",clienteData);

          const clienteInstance = new Cliente(clienteData);
          const clienteMap = clienteInstance.toMap();

          console.log("a subir info ",clienteMap);

          const response = await clientesApi.addCliente(nombreEmpresa,clienteData);

          if (response.success) {
            toast.success(`Exito: ${response.message}`);
          } else {
            toast.error(`Error: ${response.message}`);
          }

        }
        catch(error){
          console.error('Error interno al añadir cliente:', error);
          throw error;
        }

      },'Añadinedo nuevo cliente...');

    }
    //update cliente
    const updateCliente = (idNumero,nombreEmpresa,field,valor,type) =>{
      return withLoading(async () =>{
        try{
          let finalUpdateData = {};

          //validar que fiel no sea nulo
        if(!field ){
          toast.error("Este error no deberia salir");
          return;
        }

        if(type == "field" ){
          finalUpdateData = {
            [field] : valor,
          }
        } else if(type === "array_insert"){
          //actualizar array completo
          finalUpdateData = {             
            field: field,             
            data: valor // valor será el array completo de preguntas actualizado
          }
          
        }

        const respuesta = await clientesApi.updateCliente(nombreEmpresa,idNumero,type,finalUpdateData);
        
        if (respuesta.success) {
            toast.success(`Exito: ${respuesta.message}`);
          } else {
            toast.error(`Error: ${respuesta.message}`);
          }

        }
        catch(error){
          toast.error("Ocurrió un error a actualizar el cliente: " + (error.message || "Error desconocido"));
          return { success: false, error: error };
        }
      }, 'Actualizando cliente')
    }
    //obtener cliente
    const getCliente = async(nombreEmpresa,numero) =>{
      console.log("obtener cliente",nombreEmpresa,numero);
      try{
        setLoading(true);
        const data = await clientesApi.getClientePorNumero(nombreEmpresa,numero);
        const clienteObj = Cliente.fromJson(data);
        setCliente(clienteObj);
        setError(null);
        return clienteObj;
      }
      catch(error){
        console.error("Error al obtener cliente:", error);
        setError(error.message || "Error al cargar cliente");
        return null;
      }
      finally{
        setLoading(false);
      }
    }

    //eliminar cuentas
    const eliminaCuentaCliente = async(nombreEmpresa,numero,cuentaData) =>{

      return withLoading(async () =>{
      
              try{
      
                const respuesta = await clientesApi.deleteCuenta(nombreEmpresa,numero,cuentaData);
      
                if (respuesta.success) {
                  toast.success(`Exito: ${respuesta.message}`);
                } else {
                  toast.error(`Error: ${respuesta.message}`);
                }
      
              }catch(error){
                console.error('Error al eliminar la cuenta:', error);
                toast.error("Ocurrió un error en al eliminar la cuenta: " + (error.message || "Error desconocido"));
                return { success: false, error: error };
              }
      
            }, 'Porcesando Eliminacion de la cuenta...')

    }

    //obtener
    //Clientes pro plataforma
    const cargarClientesProPlataforma = async() =>{
        try{
            setLoading(true);
            const response = await clientesApi.getClientesPlataforma();
            const dataConvertida = Object.values(response);
            const serviciosObj = dataConvertida.map(item => Cliente.fromJson(item));

            console.log("clientes porplataforma",dataConvertida);
            
            setClientes(serviciosObj);
            setError(null);

            return serviciosObj;
        }
        catch(error){
            console.error("Error detallado clientes:", error);
            setError(error.message || "Error al cargar clientes");
        }
        finally{
            console.log("terminado de cargar");
            setLoading(false);
        }
    }

    //clientes buqeuda
    const cargarClientesBusqueda = async(nombreEmpresa, busqueda = '') =>{
        console.log("cargando clientes");
         try {
        setLoading(true);
        setError(null);
        
        console.log(`🔍 Cargando clientes: empresa="${nombreEmpresa}", busqueda="${busqueda}"`);
        
        const respuesta = await clientesApi.getClientes(nombreEmpresa, busqueda);
        
        if (respuesta.success) {
          console.log(`✅ Clientes cargados: ${respuesta.data.length} (Cache: ${respuesta.cached})`);
          
          // ✅ ESTO ES LO QUE FALTABA - ACTUALIZAR EL ESTADO
          const dataConvertida = Object.values(respuesta.data);
          const clientesObj = dataConvertida.map(item => Cliente.fromJson(item));
          setClientesBusqueda(clientesObj);
          
          return respuesta.data;
        } else {
          throw new Error(respuesta.error || 'Error desconocido');
        }
        
      } catch (error) {
        console.error('❌ Error al cargar clientes:', error);
        setError(error.message);
        setClientesBusqueda([]); // ✅ Limpiar en caso de error
        throw error;
      } finally {
        setLoading(false);
      }
    }
    const busquedaClientesOptions = useMemo(() => {
      if (!clientes || clientes.length === 0) {
        return [];
      }
      
      return clientes.map(cliente => ({
        value: cliente.numero,
        label: `${cliente.nombreCliente} ${cliente.numero ? `(#${cliente.numero})` : ''}`,
        numero: cliente.numero,
        cliente: cliente
      }));
    }, [clientes]);

    //metodo para busqueda
    const handleInputChange = (inputValue) => {
        console.log("a buscar");
        if (inputValue.length >= 2) { // Buscar después de 2 caracteres
        const nombreEmpresa = configuracion.nombreEmpresa; //ajustar nombre de empresa
        cargarClientesBusqueda(nombreEmpresa, inputValue);
        }
        
    };
    
    //todos los clientes
    const cargarTodosLosClientes = async() =>{
        try{
            setLoading(true);
            const response = await clientesApi.getAllClientes();
            const dataConvertida = Object.values(response);
            const serviciosObj = dataConvertida.map(item => Cliente.fromJson(item));

            setClientesAll(serviciosObj);
            setError(null);

            console.log("se obtuvieron todos los clientes",serviciosObj);

            return serviciosObj;
        }
        catch(error){
            console.error("Error obteniendo todos los clientes:", error);
            setError(error.message || "Error al cargar clientes");
        }
        finally{
            setLoading(false);
        }
    };
    const allclientesOptions = useMemo(() => {

          if (!allClientes || allClientes.length === 0) {
            return [];
          }
          
          return allClientes.map(cliente => ({
            value: cliente.numero,
            label: `${cliente.nombreCliente} ${cliente.numero ? `(#${cliente.numero})` : ''}`,
            numero: cliente.numero,
            cliente: cliente
          }));
    }, [allClientes]);
    
    //lista de campañas
    const cargarListaCampanas =async() =>{
        try{
            //setLoading(true);
            const response = await clientesApi.getCamapaList();

            setCampanalist(response);

            return campanaList;
        }
        catch(error){
            console.error("Error al obtener campañas:", error);
            setError(error.message || "Error al cargar las campañas");
        }
        finally{
            //setLoading(false);
        }
    }
    const listCampanasOptions = useMemo(() => {
    if (!campanaList || campanaList.length === 0) {
        return [];
    }
    
    return campanaList.map(campana => ({
        value: campana,
        label: campana
    }));
    }, [campanaList]);;

    const setupWebSocketsClientes = (clienteObjeto,nombreEmpresa) =>{
      if (!clienteObjeto) return;

      const socket = getSocket()

      const handleClienteUpdate = (data) => {
        // Solo actualizar si es el cliente que estamos escuchando
        if (data.clienteData.numero === clienteObjeto.numero) {
            const clienteActualizado = Cliente.fromJson(data.data);
            setCliente(clienteActualizado);
        }
    };

      if (clienteObjeto !== null){
        //a escuchar cliente

        socket.emit('join-cliente', {idCliente: clienteObjeto.numero , nombreEmpresa: nombreEmpresa});

        //regisdtrar listener de cliente id
        socket.on('cliente:id',handleClienteUpdate);
      }

      return () =>{
        //Dejar de escuchar a cliente
        socket.emit('leave-cliente', {idCliente: clienteObjeto.numero , nombreEmpresa: nombreEmpresa});
        //Eliminar listeners
        socket.off('cliente:id', handleClienteUpdate);
      }

    }

    return{
        //obj cliente
        cliente,  

        eliminaCuentaCliente,
        
        addCliente,
        getCliente,
        updateCliente,

        //listas de lcinetes
        clientes,  //clientes con busqueda
        cargarClientesBusqueda,
        busquedaClientesOptions,
        handleInputChange, // para buscar el clientes

        clientesProUnad,
        cargarClientesProPlataforma,

        allClientes,
        cargarTodosLosClientes,
        allclientesOptions,
        
        //lista de campañas
        cargarListaCampanas,
        listCampanasOptions,

        //cargas
        loadingClientes,
        errorClientes,
       
        //websocket
        setupWebSocketsClientes,
        
    }
}

export default useClientesModel